<template>
  <div class="content">
    <!-- Header with back button -->
    <header class="support-header">
      <button class="support-header__back" @click="$router.go(-1)">
        <van-icon name="arrow-left" size="20" color="#ffffff" />
      </button>
      <h1 class="support-header__title">{{ $lang.common_txt274 || 'Support' }}</h1>
      <div class="support-header__spacer"></div>
    </header>

    <!-- 原有内容 -->
    <div>
      <div class="need_help">
        <div class="need_help_p">
          <img src="../../assets/img/otgame/Support_1.png" width="100%" />
          <div
            @click="goToDDD"
            class="need_help_second t-c"
            style="margin-top: -3px"
          >
            <p class="need_help_second_t f-t-15 f-w">
              {{ $lang.common_txt274 }}
            </p>
            <p class="m-t-10">{{ $lang.common_txt275 }}</p>
            <img
              class="m-t-10 m-b-5"
              src="../../assets/img/otgame/zjm_40.png"
              width="35"
            />
            <p
              class="f-t-15"
              style="text-decoration: underline; color: #30e97f"
            >
              {{ $lang.common_txt276 }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增：常见问题折叠面板 -->
    <div>
      <div class="d-flex" style="justify-content: center">
        <p class="details_faq_left"></p>
        <p class="m-l-10 m-r-10 f-t-14" style="color: #ffbd01">
          {{ $lang.common_txt297 }}
        </p>
        <p class="details_faq_right"></p>
      </div>

      <div class="common-problems">
        <div
          class="problem-item"
          v-for="(item, index) in problemList"
          :key="index"
          @click="toggleProblem(index)"
        >
          <div class="problem-header">
            <span class="problem-question">{{ item.question }}</span>
            <van-icon
              :name="!item.isOpen ? 'arrow-down' : 'arrow-up'"
              size="14"
            />
          </div>
          <!-- 答案区域（带滑入动画） -->
          <transition name="slide-left">
            <div class="problem-answer" v-if="item.isOpen">
              <div class="problem-answer__text" v-text="item.answer"></div>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetCsLink } from '@/api/common'
import { openCustomerServiceUrl } from '@/views/layout/csLink'

export default {
  name: 'Support',
  components: {},
  data() {
    return {
      // 常见问题列表（对应图片中的内容）
      problemList: [
        {
          question: this.$lang.common_txt298,
          answer: this.$lang.common_txt299,
          isOpen: false
        },
        {
          question: this.$lang.common_txt300,
          answer: this.$lang.common_txt301,
          isOpen: false
        },
        {
          question: this.$lang.common_txt302,
          answer: this.$lang.common_txt303,
          isOpen: false
        },
        {
          question: this.$lang.common_txt304,
          answer: this.$lang.common_txt305,
          isOpen: false
        },
        {
          question: this.$lang.common_txt306,
          answer: this.$lang.common_txt307,
          isOpen: false
        }
      ]
    }
  },
  methods: {
    async goToDDD() {
      try {
        const data = await GetCsLink()
        if (openCustomerServiceUrl(data, 'official')) return
      } catch (e) {
        // Keep the support entry usable when the read-only API is unavailable.
      }
      openCustomerServiceUrl(null, 'official')
    },
    // 切换问题的展开/收起
    toggleProblem(index) {
      // 关闭其他问题，只保持一个展开（可选逻辑，可删除）
      this.problemList.forEach((item, i) => {
        if (i !== index) item.isOpen = false
      })
      // 切换当前问题的状态
      this.problemList[index].isOpen = !this.problemList[index].isOpen
    }
  },
  mounted() {}
}
</script>

<style lang="less" scoped>
.support-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  background: #1a1d29;

  &__back {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    background: none;
    border: none;
    cursor: pointer;
  }

  &__title {
    font-size: var(--vk-fs-md);
    font-weight: 700;
    color: #ffffff;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  &__spacer {
    width: 40px;
  }
}

.need_help_p {
  background: url(../../assets/img/otgame/Support_4.png) no-repeat;
  background-size: 100% 100%;
  padding: 20px;
}
.need_help_second {
  background: url(../../assets/img/otgame/Support_3.png) no-repeat;
  background-size: 100% 100%;
  padding: 6px 0;
}
.need_help_second_t {
  background: linear-gradient(180deg, #ffe400, #feffd4);
  -webkit-background-clip: text;
  color: transparent;
}

/* 新增：常见问题样式 */
.common-problems {
  margin: 10px;
  background: #2c2f3e; /* 深色背景，匹配你的界面风格 */
  border-radius: 8px;
  padding: 5px 15px 10px;
}

.problem-item {
  border-bottom: 1px solid #474a57;
  padding: 10px 0;
  cursor: pointer;
}
.problem-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ccdaed;
  font-size: var(--vk-fs-sm);
}
.arrow-icon {
  color: #fff;
  transition: transform 0.3s ease;
}
/* 箭头旋转动画 */
.rotate {
  transform: rotate(180deg);
}
.problem-answer {
  color: #30e97f; /* 绿色文字，匹配你的界面 */
  margin-top: 10px;
  padding-left: 5px;
  line-height: 1.6;
}
/* 文字从左滑出动画 */
.slide-left-enter-from,
.slide-left-leave-to {
  transform: translateX(-20px);
  opacity: 0;
}
.slide-left-enter-active,
.slide-left-leave-active {
  transition: all 0.3s ease;
}
.details_faq_left {
  background: linear-gradient(90deg, #292c3d, #4a4d61);
  width: 25%;
  height: 2px;
}
.details_faq_right {
  background: linear-gradient(90deg, #4a4d61, #292c3d);
  width: 25%;
  height: 2px;
}
</style>
